import { z } from 'zod/v4';

import { createdAtSchemaLegacy, styleBagSchema } from '../../../common/schemas/legacy';

import { imageLegacyZeroDataSchema } from './data';
import { imageStylesSchemaLegacy } from './styles';

/**
 * Zero-block-placement legacy image envelope.
 *
 * `type: z.literal('zero')` is required (no `.optional()`): an image created
 * inside a zero block carries the tag end-to-end so positioning hosts and
 * render branches can recognise the placement. The host-app factory copies
 * `meta.type` onto the entity at creation time.
 *
 * Inner data uses {@link imageLegacyZeroDataSchema} — the extended-position
 * grid plus the `imagePosition` focal-point keyword. `styles` is the same
 * structured image styles group as the default envelope.
 */
export const imageLegacyZeroV0Schema = z.object({
    id: z.string(),
    name: z.literal('image'),
    columnId: z.string(),
    structureId: z.string().nullish(),
    displayId: z.string().nullish(),
    createdAt: createdAtSchemaLegacy,
    type: z.literal('zero'),
    data: imageLegacyZeroDataSchema,
    styles: imageStylesSchemaLegacy,
    mobileStyles: styleBagSchema.nullish(),
});
